
  <h1 *ngIf="displayHeader" class="page-header"><i class="fa fa-star" aria-hidden="true"></i> ASSETS</h1>

<!-- Main Screen which shows the Assets Objects and Asset Instances -->
<div class="infrastructure-tabs" id="objectContentPane">

	<!-- Tab Navigation Control -->
	<ul class="nav nav-tabs">
		<li class="active"><a data-toggle="tab" href="#asset-instances-tab" aria-expanded="true"><i class="fa fa-star-o"></i> ASSETS</a></li>
		<li><a data-toggle="tab" href="#asset-objects-tab" aria-expanded="false"><i class="fa fa-star-o"></i> ASSET TYPES</a></li>
	</ul>

	<!-- Tab Content -->
	<div class="tab-content">

		<!-- Asset Objects Tab -->
		<div id="asset-objects-tab" class="tab-pane fade">

			<!-- Add Asset Type and Options buttons -->
			<button (click)="addAssetClicked()" type="button" class="btn btn-primary"><em class="fa fa-plus"></em> ADD
				ASSET TYPE</button>
			<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				<button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"><em
						class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
				<ul class="dropdown-menu">
					<li (click)="editSelectedAssetClicked()" [class.disabled]="!isSingleAssetTypeSelected()"><a><em
								class="fa fa-pencil"></em> EDIT</a></li>
					<li (click)="duplicateSelectedAssetClicked()" [class.disabled]="!isSingleAssetTypeSelected()"><a><em
								class="fa fa-clone"></em> DUPLICATE</a></li>
					<li (click)="deleteSelectedAssetsClicked()" [class.disabled]="!isAnyAssetTypesSelected()"><a><em
								class="fa fa-remove"></em> DELETE</a></li>
					<li class="divider"></li>
					<li (click)="addAssetTypesToGroupClicked()" [class.disabled]="!isAnyAssetTypesSelected()"><a><em
								class="fa fa-plus"></em> ADD TO GROUP</a></li>
					<li (click)="removeAssetTypesFromGroupClicked()" [class.disabled]="!isAnyAssetTypesSelected()">
						<a><em class="fa fa-remove"></em> REMOVE FROM GROUP</a></li>
					<li (click)="manageAssetTypeGroups()"><a><em class="fa fa-pencil"></em> MANAGE GROUPS</a></li>
					<li class="divider"></li>
					<li (click)="uploadTypeFileClicked()"><input type="file" #typeFileUpload
							(change)="onTypeFileUploadChange($event)" style="display:none" /><a><em
								class="fa fa-upload"></em> UPLOAD TYPES </a></li>
					<li (click)="downloadTypes()"><a><em class="fa fa-download"></em> DOWNLOAD TYPES </a></li>
					<li (click)="downloadAssets()" [class.disabled]="!isSingleAssetTypeSelected()"><a><em
								class="fa fa-download"></em> DOWNLOAD ASSETS </a></li>
				</ul>
			</div>


			<!-- "Filter" Button w/ drop down options -->
			<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
					<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
				</button>
				<ul class="dropdown-menu">
					<li *ngFor="let filterOption of filterOptionsForTypes" (click)="onFilterOptionForTypesClicked(filterOption)">
						<a>{{ filterOption.label }}</a>
					</li>
				</ul>
			</div>

			<!-- Filter Label (if a Filter Option is selected) -->
			<div *ngIf="filterOptionForTypes?.column != null" 
				class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				{{ filterOptionForTypes.label }}
			</div>

			<!-- Filter Value (if a Filter Option is selected)-->
			<div *ngIf="filterOptionForTypes?.column != null" 
				class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				<input class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20"
					[(ngModel)]="filterValueForTypes"
					(ngModelChange)="onFilterValueForTypesChanged()">
			</div>

			<!-- Result Per Page (if selected or else default) -->
			<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
						class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
						<ul class="dropdown-menu">
							<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForTypes(value)" [class.active]="value === selectedPageSizeValueForTypes">
								<a>{{ value }}</a>
							</li>
						</ul>
			</div>

			<!-- Asset Objects -->
			<table class="table tablesorter tablesorter-default table-hover" data-toggle="table" data-id-field="userid"
				role="grid">
				<thead>
					<tr role="row" class="tablesorter-headerRow">
						<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
							scope="col" role="columnheader" aria-disabled="false" aria-controls="table1"
							aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
							style="user-select: none;">
							<div class="tablesorter-header-inner">
								<div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
										[checked]="isAllAssetTypesSelected()"
										(change)="setAllAssetTypesSelected($event)"><label for="checkbox"></label></div>
							</div>
						</th>
						<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
							data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
							role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
							aria-label="Name: No sort applied, activate to apply an ascending sort">
							<div class="tablesorter-header-inner">Name</div>
						</th>
						<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
							data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
							role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
							aria-label="Groups: No sort applied, activate to apply an ascending sort">
							<div class="tablesorter-header-inner">Groups</div>
						</th>
					</tr>
				</thead>
				<tbody aria-live="polite" aria-relevant="all">
					<ng-container *ngFor="let assetTypeUi of mAssetTypeUis | paginate: {id: 'assettype_pagination', itemsPerPage: selectedPageSizeValueForTypes, currentPage: currentPageForTypes, totalItems: totalNumberOfTypes }">
						<tr class="" role="row">
							<td>
								<div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
										[(ngModel)]="assetTypeUi.mSelected"><label for="checkbox"></label></div>
							</td>
							<td (click)="editAsset(assetTypeUi.mAssetType)">{{assetTypeUi.mAssetType.name}}</td>
							<td>
								<ng-container
									*ngIf="assetTypeUi.mAssetType.groups != null && assetTypeUi.mAssetType.groups.length > 0">
									<ng-container *ngFor="let group of assetTypeUi.mAssetType.groups">
										<button class="groupButton" (click)="showGroup(group)">{{group.name}}</button>
									</ng-container>
								</ng-container>
							</td>
						</tr>
					</ng-container>
				</tbody>
			</table>

			<!-- Pagination Controls for the "Asset" Types (controls referenced in the *ngFor for the table data above) -->
			<pagination-controls class="pagination" id="assettype_pagination" (pageChange)="onTypePageChange($event)"
				[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
			</pagination-controls>

		</div>



		<!-- Asset Instances Tab -->
		<div id="asset-instances-tab" class="tab-pane fade active in">

			<!-- Add Asset and Options buttons -->
			<button (click)="addAssetInstanceClicked()" type="button" class="btn btn-primary"><em
					class="fa fa-plus"></em> ADD ASSET</button>
			<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				<button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"><em
						class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
				<ul class="dropdown-menu">
					<li (click)="editSelectedAssetInstanceClicked()"
						[class.disabled]="!isSingleAssetInstanceSelected()"><a><em class="fa fa-pencil"></em> EDIT</a>
					</li>
					<li (click)="duplicateSelectedAssetInstanceClicked()"
						[class.disabled]="!isSingleAssetInstanceSelected()"><a><em class="fa fa-clone"></em>
							DUPLICATE</a></li>
					<li (click)="deleteSelectedAssetInstancesClicked()"
						[class.disabled]="!isAnyAssetInstancesSelected()"><a><em class="fa fa-remove"></em> DELETE</a>
					</li>
					<li class="divider"></li>
					<li (click)="addAssetInstancesToGroupClicked()" [class.disabled]="!isAnyAssetInstancesSelected()">
						<a><em class="fa fa-plus"></em> ADD TO GROUP</a></li>
					<li (click)="removeAssetInstancesFromGroupClicked()"
						[class.disabled]="!isAnyAssetInstancesSelected()"><a><em class="fa fa-remove"></em> REMOVE FROM
							GROUP</a></li>
					<li (click)="manageAssetInstanceGroups()"><a><em class="fa fa-pencil"></em> MANAGE GROUPS</a></li>
					<li class="divider"></li>
					<li (click)="uploadInstanceFileClicked()"><input type="file" #fileInstanceUpload
							(change)="onInstanceFileUploadChange($event)" style="display:none" /><a><em
								class="fa fa-upload"></em> UPLOAD ASSETS </a></li>
				</ul>
			</div>

			<!-- "Filter" button w/ drop down options -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li *ngFor="let filterOption of filterOptionsForInstances" (click)="onFilterOptionForInstancesClicked(filterOption)">
							<a>{{ filterOption.label }}</a>
						</li>
					</ul>
				</div>

				<!-- Filter Label (if a Filter Option is selected) -->
				<div *ngIf="filterOptionForInstances?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					{{ filterOptionForInstances.label }}
				</div>

				<!-- Filter Value (if a Filter Option is selected)-->
				<div *ngIf="filterOptionForInstances?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<input class="form-control ng-pristine ng-valid ng-untouched" type="text"
						[(ngModel)]="filterValueForInstances"
						(ngModelChange)="onFilterValueForInstancesChanged()">
				</div>

				<!-- Result Per Page (if selected or else default) -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForInstances(value)" [class.active]="value === selectedPageSizeValueForInstances">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>


			<!-- Asset Instances -->
			<table class="table tablesorter tablesorter-default table-hover" data-toggle="table" data-id-field="userid"
				role="grid">
				<thead>
					<tr role="row" class="tablesorter-headerRow">
						<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
							scope="col" role="columnheader" aria-disabled="false" aria-controls="table2"
							aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
							style="user-select: none;">
							<div class="tablesorter-header-inner">
								<div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
										[checked]="isAllAssetInstancesSelected()"
										(change)="setAllAssetInstancesSelected($event)"><label for="checkbox"></label>
								</div>
							</div>
						</th>
						<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
							data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
							role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
							aria-label="Name: No sort applied, activate to apply an ascending sort">
							<div class="tablesorter-header-inner">Name</div>
						</th>
						<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
							data-field="object" data-sortable="true" data-column="2" tabindex="0" scope="col"
							role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
							aria-label="Asset Type: No sort applied, activate to apply an ascending sort">
							<div class="tablesorter-header-inner">Asset Type</div>
						</th>
						<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
							data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col"
							role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
							aria-label="Groups: No sort applied, activate to apply an ascending sort">
							<div class="tablesorter-header-inner">Groups</div>
						</th>
					</tr>
				</thead>
				<tbody aria-live="polite" aria-relevant="all">
					<ng-container *ngFor="let assetInstanceUi of mAssetInstanceUis | paginate: {id: 'assetinstance_pagination', itemsPerPage: selectedPageSizeValueForInstances, currentPage: currentPageForInstances, totalItems: totalNumberOfInstances}">
						<tr class="" role="row">
							<td>
								<div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
										[(ngModel)]="assetInstanceUi.mSelected"><label for="checkbox"></label></div>
							</td>
							<td (click)="editAssetInstance(assetInstanceUi.mAssetInstance)"  (contextmenu)="fetchFunctionList($event, assetInstanceUi.mAssetInstance)">
								{{assetInstanceUi.mAssetInstance.name}}</td>
							<td (click)="editAssetInstance(assetInstanceUi.mAssetInstance)">
								{{assetInstanceUi.mAssetInstance.object.name}}</td>
							<td>
								<ng-container
									*ngIf="assetInstanceUi.mAssetInstance.groups != null && assetInstanceUi.mAssetInstance.groups.length > 0">
									<ng-container *ngFor="let group of assetInstanceUi.mAssetInstance.groups">
										<button class="groupButton" (click)="showGroup(group)">{{group.name}}</button>
									</ng-container>
								</ng-container>
							</td>
						</tr>
					</ng-container>
				</tbody>
			</table>

			<!-- Pagination Controls for the "Asset" Instance (controls referenced in the *ngFor for the table data above) -->
			<pagination-controls class="pagination" id="assetinstance_pagination"
					(pageChange)="onInstancePageChange($event)" [directionLinks]="true"
					nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

	</div>
	</div>
</div>

<app-entity-type-dialog #entityTypeDialog [entity]="mEntity" [entityName]="mEntityName" [entityType]="mEntityType"
	[entityTypeName]="mEntityTypeName" (createOrUpdateEvent)="createOrUpdateEntityType()"
	(showGroup)="showGroup($event)">
</app-entity-type-dialog>

<app-entity-instance-dialog #entityInstanceDialog [instance]="mInstance" 
	[instanceName]="mInstanceName" [instanceEntityType]="mInstanceEntityType" [objectCategory]="mObjectCategory"
	[instanceType]="mInstanceType" [instanceTypeName]="mInstanceTypeName" [availableEntityTypes]="mAvailableEntityTypes"
	[availableTags]="mAvailableTags" [selectedTags]="mSelectedTags"
	(createOrUpdateEvent)="createOrUpdateEntityInstance()" (showGroup)="showGroup($event)"
	(selectedEntityTypeChangedEvent)="selectedEntityTypeChanged($event)"
	(refreshInstanceDataEvent)="refreshInstanceData()" (selectedTagChangedEvent)="selectedTagChanged($event)">
</app-entity-instance-dialog>

<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()"></app-confirm-delete-dialog>
<app-show-group-dialog #showGroupDialog></app-show-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addSelectedToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog (confirmEvent)="removeSelectedFromGroup($event)">
</app-remove-from-group-dialog>

<!-- Right Click dropdown menu -->
<app-dropdown-menu *ngIf="showContextMenu" [x]="contextMenuPosition.x" [y]="contextMenuPosition.y"
	[items]="functionList" (selectedItemChange)="onItemClicked($event)"></app-dropdown-menu>

<!-- Going further if we want to display the function execution status
	<app-function-executing-dialog  #functionExecutingDialog (functionExecutionStartEvent)="functionStartingToExecute($event)" (functionExecutionSuccessEvent)="functionFinishedExecutingSuccessfully()" (functionExecutionErrorEvent)="functionFinishedExecutingWithError($event)"></app-function-executing-dialog> -->

<app-general-function-dialog *ngIf="showGeneralDialog" #generalDialog [instance]="mInstance" [instanceType]="mInstanceType"
	[function]="selectedFunction"></app-general-function-dialog>

<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>